module.exports = __webpack_public_path__ + "static/img/Jaipur_Cinema-2.3fb7de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/Jaipur_Cinema-2.jpg
// module id = Ll1L
// module chunks = 11